import {
  CreativeProps,
  DOMBuilder,
  EventEmitter,
  Renderable
} from '../../types';
import { CreativeTagEvent } from '../../enums';
import { CreativeEventEmitter } from '../../event-emitter/creative-event-emitter';
import { ImageContainerBuilder, ImageTagBuilder } from './dom-builders';
import { BackgroundBuilder } from './dom-builders/background-builder';

export function assign(target: any, ...sources: any[]) {
  sources.forEach(source => {
    for (const key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  });
  return target;
}

export class ImageCreative
  implements Renderable<CreativeProps>, EventEmitter<CreativeTagEvent> {
  private readonly creativeEventEmitter = new CreativeEventEmitter();

  private imageTagContainer: HTMLDivElement | null = null;
  private imageTag: HTMLImageElement | null = null;

  constructor(private domBuilder: DOMBuilder) {}

  public addEventListener(
    event: CreativeTagEvent,
    callback: (evt?: Event) => void
  ) {
    this.creativeEventEmitter.addEventListener(event, evt => callback(evt));
  }

  public emit(event: CreativeTagEvent, evt?: Event) {
    this.creativeEventEmitter.emit(event, evt);
  }

  public render(props: CreativeProps): HTMLElement {
    this.imageTagContainer = ImageContainerBuilder.create(
      props,
      this.domBuilder
    );
    this.imageTag = ImageTagBuilder.create(
      props,
      this.domBuilder
    ) as HTMLImageElement;

    this.listenToImageTagEvents(this.imageTagContainer, this.imageTag);

    if (props.backgroundColor) {
      BackgroundBuilder.create(
        {
          backgroundColor: props.backgroundColor,
          container: this.imageTagContainer
        },
        this.domBuilder
      );
    }
    this.imageTagContainer.appendChild(this.imageTag);

    return this.imageTagContainer;
  }

  public updateStyle(props: CreativeProps): void {
    ImageTagBuilder.addContainerStyle(this.imageTagContainer!, props);
    ImageTagBuilder.addImageStyle(this.imageTag!, props);
  }

  protected listenToImageTagEvents(
    imageTagContainer: HTMLElement,
    imageTag: HTMLElement
  ): void {
    imageTagContainer.addEventListener('click', evt => {
      this.emit(CreativeTagEvent.CreativeClicked, evt);
    });

    imageTag.addEventListener('load', evt => {
      this.emit(CreativeTagEvent.CreativeAssetLoad, evt);
    });

    imageTag.addEventListener('error', evt => {
      this.emit(CreativeTagEvent.CreativeLoadingFailed, evt);
    });
  }
}
